export class AppCommonUtils {
    static getCurrentRoute(currentUrl: string): string {
        const currentUrlArray = currentUrl.split('/');

        let currentRoute = currentUrlArray[currentUrlArray.length - 1].toLowerCase();

        if (currentRoute.indexOf('?') != -1) {
            const currentRouteArray = currentRoute.split('?');

            currentRoute = currentRouteArray[0].toLowerCase();
        }

        return currentRoute;
    }

    static isMobileDevice(): boolean {
        if (typeof navigator === 'undefined') {
            // Running on the server (SSR) — no UA available, treat as desktop.
            return false;
        }

        const ua = navigator.userAgent;

        if (/Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
            return true;
        }

        return false;
    }
}
